import {
  UPDATE_TENANT,
  UPDATE_TENANT_SUCCESS,
  UPDATE_TENANT_ERROR,
  UPDATE_TENANT_EDIT_STATE,
} from "../../actions";

const INIT_STATE = {
  isEditTenantPanelShown: false,
  tenant: null,
  primaryContact: null,
  primaryOrganization: null,
  loading: false,
  editTenantError: null,
  editTenantSuccess: null,
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_TENANT:
      return { ...state, loading: true, editTenantError: null };
    case UPDATE_TENANT_SUCCESS:
      return { ...state, loading: false, editTenantError: null, editTenantSuccess: action.payload.successMessage, isEditTenantPanelShown: false };
    case UPDATE_TENANT_ERROR:
      return { ...state, loading: false, editTenantError: action.payload.message };
    case UPDATE_TENANT_EDIT_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};
